import ClaimListing, { ClaimColumns, ClaimFilters } from '../shared/ClaimListing/ClaimListing';

export default function DeadReportTab() {
  return (
    <ClaimListing
      openDeadReports
      autoCheckout={false}
      defaultRowsPerPage={50}
      columns={[
        ClaimColumns.insuredName,
        ClaimColumns.reinsuranceYear,
        ClaimColumns.policyNumber,
        ClaimColumns.sce,
        ClaimColumns.state,
        ClaimColumns.county,
        ClaimColumns.type,
        ClaimColumns.effectiveDate,
        ClaimColumns.endDate,
        ClaimColumns.hc,
        ClaimColumns.targetCwt,
        ClaimColumns.coveragePrice,
      ]}
      filters={[{...ClaimFilters.insuredName, autoFocus: true }]}
      additionalPayload={{
        status: null,
        deadReportEligible: true,
        specialSort: 'insuredName,reinsuranceYear,policyNumber,sce',
      }}
      columnsSortable={false}
      includeExport={false}
    />
  );
}
